import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cn } from '@/lib/utils'

/**
 * Form label.
 *
 * The required marker is drawn with a CSS `::after` rather than a DOM node, so the
 * asterisk never becomes part of the field's accessible name — a screen reader announces
 * "Password", not "Password star". Requiredness is conveyed to assistive technology by
 * `required`/`aria-required` on the input itself.
 */
export const Label = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & { required?: boolean }
>(({ className, required, children, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    data-required={required ? 'true' : undefined}
    className={cn(
      'text-sm font-medium text-[var(--color-heading)]',
      "data-[required=true]:after:ms-0.5 data-[required=true]:after:text-[var(--color-danger)] data-[required=true]:after:content-['*']",
      className,
    )}
    {...props}
  >
    {children}
  </LabelPrimitive.Root>
))
Label.displayName = 'Label'
